"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const js_cookie_1 = __importDefault(require("js-cookie"));
const config_1 = __importDefault(require("next/config"));
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const graphql_types_1 = require("@hotelplan/graphql.types");
const libs_utils_1 = require("@hotelplan/libs.utils");
const WarningNotification_1 = __importDefault(require("./WarningNotification"));
const { publicRuntimeConfig: { brand }, } = (0, config_1.default)();
const NOTIFICATION_KEY_PREFIX = `${brand === null || brand === void 0 ? void 0 : brand.toLowerCase()}_notification`;
const InformationNotificationWrap = (0, styled_components_1.default)(WarningNotification_1.default)(({ theme }) => (Object.assign({}, theme.notifications.mantainanceNotification)), ({ backgroundColor, solidBg }) => backgroundColor
    ? {
        border: `2px solid ${backgroundColor}`,
        '.notification-heading': { backgroundColor },
        '.notification-body': solidBg ? { backgroundColor } : null,
    }
    : null);
const InformationNotifications = ({ notificationData, className, solidBg = false, }) => {
    const [closedNotifications, setClosedNotifications] = (0, react_1.useState)([]);
    const now = new Date();
    return (react_1.default.createElement("div", null, libs_utils_1.isBrowser &&
        (notificationData || []).map((notification, i) => {
            const rawExpTime = js_cookie_1.default.get(`${NOTIFICATION_KEY_PREFIX}_${notification.id}`);
            const expTime = parseInt(rawExpTime || '0', 10);
            if (closedNotifications.includes(notification.id || ''))
                return null;
            if (rawExpTime === '0')
                return null;
            if (rawExpTime && expTime >= now.valueOf())
                return null;
            return (react_1.default.createElement(InformationNotificationWrap, { key: notification.id || i, title: notification.mainTitle || '', text: notification.mainText || '', backgroundColor: notification.backgroundColor, solidBg: solidBg, testId: `information-notification-${notification.id}`, className: className, onClose: notification.closable
                    ? () => {
                        let timeStamp = 0;
                        switch (notification.showIfClosed) {
                            case graphql_types_1.MaintenanceNotificationShowMode.OnceEvery_2Hours:
                                timeStamp = (0, libs_utils_1.addHours)(now, 2).valueOf();
                                break;
                            case graphql_types_1.MaintenanceNotificationShowMode.OnceEvery_24Hours:
                                timeStamp = (0, libs_utils_1.addHours)(now, 24).valueOf();
                                break;
                        }
                        js_cookie_1.default.set(`${NOTIFICATION_KEY_PREFIX}_${notification.id}`, timeStamp.toString(), { expires: 31 });
                        setClosedNotifications([
                            ...closedNotifications,
                            notification.id || '',
                        ]);
                    }
                    : undefined }));
        })));
};
exports.default = InformationNotifications;
//# sourceMappingURL=InformationNotifications.js.map